export default function UserReducer(state: any, user: any): any {
  return user;
}
